namespace TabAurous.ECommerce {
    export namespace SeasonalityService {
        export const baseUrl = 'ECommSales/Seasonality';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommSales/Seasonality/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>SeasonalityService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
